module.exports = "/_next/static/images/A-a6b6b4cbeebbef7e02f4dd1f2662e52d.png";